import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/app/ui/assets/svg/sti-reverse-scan/icon-sti-dest.svg'
import _imports_1 from '@/app/ui/assets/svg/sti-reverse-scan/icon-sti.svg'


const _hoisted_1 = {
  class: "flex flex-col gap-2 justify-center",
  style: {"width":"fit-content"}
}
const _hoisted_2 = { class: "flex flex-row items-center justify-center" }
const _hoisted_3 = { class: "flex flex-row items-center gap-4 justify-center" }
const _hoisted_4 = {
  key: 0,
  src: _imports_0,
  alt: "sti-sti-dest-icon"
}
const _hoisted_5 = {
  key: 1,
  src: _imports_1,
  alt: "sti-sti"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("img", {
        src: `@/app/ui/assets/svg/sti-reverse-scan/icon-taken-by-recipient${_ctx.isAccountForeign ? '-en' : ''}.svg`,
        alt: "taken-by-recipient-icon"
      }, null, 8, ["src"])
    ]),
    _createVNode("div", _hoisted_3, [
      (_ctx.isStiDest)
        ? (_openBlock(), _createBlock("img", _hoisted_4))
        : (_openBlock(), _createBlock("img", _hoisted_5))
    ])
  ]))
}